export default "__VITE_ASSET__BZYRxKOL__"